module.exports = __webpack_public_path__ + "img/O green1 copy.3ff1af18.png";